import React from "react";
import { Box, Dialog, DialogContent } from '@mui/material';
import { useSelector } from "react-redux";

export default function ProcessingPopup(props) {
    const processing = useSelector(state => state.processing);
    console.log(processing);

    const renderMessage = () => {
        if(processing.show) {
            return (processing.message.length > 0) ? processing.message : "Processing...";
        } else {
            return "";
        }
    }
    return (
        <Dialog
        disableEscapeKeyDown={true}
        open={processing.show}
        >
            <DialogContent>
                <Box>{renderMessage()}</Box>
            </DialogContent>
        </Dialog>
  );
}